import { Config } from "@measured/puck"
import { Box } from "./blocks/Box"
import { Button } from "./blocks/Button"
import { Columns } from "./blocks/Columns"
import { Container } from "./blocks/Container"
import { Gallery as GalleryConfig } from "./blocks/Gallery"
import { GalleryLayout as GalleryLayoutConfig } from "./blocks/GalleryLayout"
import { Heading } from "./blocks/Heading"
import { IconSocial } from "./blocks/IconSocial"
import { Image as ImageConfig } from "./blocks/Image"
import { ImageCard } from "./blocks/ImageCard"
import { Input } from "./blocks/Input"
import { PhotoLibrary } from "./blocks/PhotoLibrary"
import { PostGridByCategory as PostGridByCategoryConfig } from "./blocks/PostGridByCategory"
import { ProfileUserCard } from "./blocks/ProfileUserCard"
import { SimpleSlider as SimpleSliderConfig } from "./blocks/SimpleSliders"
import { Text } from "./blocks/Text"
import { VericalSpace } from "./blocks/VerticalSpace"
import { Video as VideoConfig } from "./blocks/Video"
import { VideoLibrary } from "./blocks/VideoLibrary"
import { ArticlesItemsList } from "./themes/caocao/ArticlesItemsList/ArticlesItemsList"
import { CaoCaoButton } from "./themes/caocao/CaoCaoButton/CaoCaoButton"
import { CaoCaoCarousel } from "./themes/caocao/CaoCaoCarousel/CaoCaoCarousel"
import { CaoCaoContact } from "./themes/caocao/CaoCaoContact/CaoCaoContact"
import { CaoCaoFeedback } from "./themes/caocao/CaoCaoFeedback/CaoCaoFeedback"
import { CaoCaoFooter } from "./themes/caocao/CaoCaoFooter/CaoCaoFooter"
import { CCACustomMedia } from "./themes/caocao/CaoCaoMedia/CustomMedia"
import { CaoCaoNavigation } from "./themes/caocao/CaoCaoNavigation/CaoCaoNavigation"
import { CaoCaoSlider } from "./themes/caocao/CaoCaoSlider/CaoCaoSlider"
import { CustomTours } from "./themes/caocao/CustomTours/CustomTours"
import { CCACardProfile } from "./themes/caocao/EnrollmentCard/CCACardProfile"
import { CCAFormCustomizeTour } from "./themes/caocao/FormCustomizeTour"
import { LocationMap } from "./themes/caocao/LocationMap/LocationMap"
import { SinglePost } from "./themes/caocao/SinglePost/SinglePost"
import { ButtonMABG } from "./themes/manu-bacgiang/Button"
import { ManuCountdownBG } from "./themes/manu-bacgiang/Countdown/ManCountdown"
import { FormRegisterBG } from "./themes/manu-bacgiang/FormRegister"
import { ManuDropDownBG } from "./themes/manu-bacgiang/ManDropDown"
import { ButtonMA } from "./themes/manu/Button"
import { FormRegister } from "./themes/manu/FormRegister"
import { SliderScroll } from "./themes/manu/SliderScroll"
import { SKELPEnrollmentCard } from "./themes/ske-landing-page/EnrollmentCard/SKEEnrollmentCard"
import { SKELPEnrollmentCard2 } from "./themes/ske-landing-page/EnrollmentCard2/SKEEnrollmentCard"
import { SKELPFormRegister } from "./themes/ske-landing-page/FormRegister"
import { SKELPGalleryLayout } from "./themes/ske-landing-page/GalleryLayout"
import { SKELPRegister } from "./themes/ske-landing-page/SKESchoolSystem/SKESchoolSystem"
import { SKELPCustomTabs } from "./themes/ske-landing-page/Tabs"
import { SKELPTuitionCard } from "./themes/ske-landing-page/TuitionCard/SKEEnrollmentCard"
import { SKEActionButton } from "./themes/ske/ActionButton/SKEActionButton"
import { SKEBaseSystem } from "./themes/ske/BaseSystem"
import { SKEContactForm } from "./themes/ske/ContactForm"
import { SKEContactHero } from "./themes/ske/ContactHero"
import { SKEContentDescription } from "./themes/ske/ContentDescription/SKEContentDescription"
import { SKEContentHeading } from "./themes/ske/ContentHeading/SKEContentHeading"
import { SKEContentText } from "./themes/ske/ContentText/SKEContentText"
import { ManCountdown } from "./themes/ske/Countdown/ManCountdown"
import { SKEEducationalCard } from "./themes/ske/EducationalCard/SKEEnrollmentCard"
import { SKEEnrollmentCard } from "./themes/ske/EnrollmentCard/SKEEnrollmentCard"
import { SKEEnrollmentProcess } from "./themes/ske/EnrollmentProcess/SKEEnrollmentProcess"
import { ImageFlip } from "./themes/ske/ImageFlip"
import { ImageSection } from "./themes/ske/ImageSection"
import { ManDropDown } from "./themes/ske/ManDropDown"
import { MultiLayout } from "./themes/ske/MultiLayout"
import { SKEProcessSlide } from "./themes/ske/ProcessSlide/ProcessSlide"
import { RelationshipLayout } from "./themes/ske/RelationshipLayout"
import { SKEFooter } from "./themes/ske/SKEFooter/SKEFooter"
import { SKENavigation } from "./themes/ske/SKENavigation/SKENavigation"
import { SKERecruiment } from "./themes/ske/SKERecruitment/SKERecruitment"
import { SKESchoolSystem } from "./themes/ske/SKESchoolSystem/SKESchoolSystem"
import { SKESimpleSlider } from "./themes/ske/SKESimpleSlider/SKESimpleSlider"
import { SKETabBlockWithMedia } from "./themes/ske/SKETabBlockWithMedia/SKETabBlockWithMedia"
import { SKECustomTabs } from "./themes/ske/Tabs"
import { SKETitle } from "./themes/ske/Tittle/SKETitle"
import { BannerTrangChu } from "./themes/skylink-careers/bannerTrangChu/bannerTrangChu"
import { CompaniesSection } from "./themes/skylink-careers/CompaniesSection/index"
import { DepartmentRecruitment } from "./themes/skylink-careers/DepartmentRecruitment/DepartmentRecruitment"
import { FindInput } from "./themes/skylink-careers/FindInput/FindInput"
import { CareersFooter } from "./themes/skylink-careers/Footer/CareersFooter"
import { ImageGrid } from "./themes/skylink-careers/GridImage/GridImage"
import { SectionFilter } from "./themes/skylink-careers/SectionFilter/SectionFilter"
import { SectionQTTuyenDung } from "./themes/skylink-careers/SectionQTTuyenDung/SectionQTTuyenDung"
import { SeeMoreSection } from "./themes/skylink-careers/SeeMoreSection/SeeMoreSection"
import { ApplyForm } from "./themes/skylink-studio/ApplyForm/index"
import { Benefits } from "./themes/skylink-studio/benefits/index"
import { ContactForm } from "./themes/skylink-studio/ContactForm/index"
import { SKLFooter } from "./themes/skylink-studio/Footer/SKLFooter"
import { GameGrid } from "./themes/skylink-studio/GameGrid"
import { GameSlider } from "./themes/skylink-studio/GameSlider"
import { GGMap } from "./themes/skylink-studio/GGMap/index"
import { GridImageSKS } from "./themes/skylink-studio/GridImage/index"
import { JobGrid } from "./themes/skylink-studio/JobGrid/index"
import { VideoAutoPlay } from "./themes/skylink-studio/Video/index"

const components = {
  Container,
  Columns,
  Box,
  VericalSpace,
  Heading,
  Text,
  Button,
  CustomTabs,
  ButtonLocation,
  ImageCard,
  ProfileUserCard,
  SKETitle,
  SKEActionButton,
  SKEContentHeading,
  SKEContentText,
  SKEContentDescription,
  PhotoLibrary,
  VideoLibrary,
  DropDown,
  VideoConfig,
  ImageConfig,
  GalleryConfig,
  GalleryLayoutConfig,
  SimpleSliderConfig,
  PostGridByCategoryConfig,
  // New components
  MultiLayout,
  SKERecruiment,
  IconSocial,
  RelationshipLayout,
  SKEEnrollmentProcess,
  SKEEnrollmentCard,
  ImageSection,
  ManCountdown,
  Input,
  ManDropDown,
  SliderScroll,
  FormRegister,
  ButtonMA,
  SKESchoolSystem,
  SKESimpleSlider,
  SKEFooter,
  SKENavigation,
  ButtonMABG,
  ManuCountdownBG,
  FormRegisterBG,
  ManuDropDownBG,
  BannerTrangChu,
  CompaniesSection,
  SeeMoreSection,
  FindInput,
  ImageGrid,
  SectionFilter,
  SectionQTTuyenDung,
  SKELPEnrollmentCard,
  SKELPGalleryLayout,
  SKELPCustomTabs,
  SKECustomTabs,
  SKELPRegister,
  SKELPTuitionCard,
  SKELPFormRegister,
  SKELPEnrollmentCard2,
  GameSlider,
  GameGrid,
  GridImageSKS,
  VideoAutoPlay,
  SKEEducationalCard,
  SKEProcessSlide,
  SKEBaseSystem,
  SKEContactForm,
  SKEContactHero,
  DepartmentRecruitment,
  SKETabBlockWithMedia,
  CaoCaoButton,
  CaoCaoCarousel,
  CaoCaoFeedback,
  CaoCaoFooter,
  CaoCaoNavigation,
  CaoCaoSlider,
  CustomTours,
  CaoCaoContact,
  LocationMap,
  ArticlesItemsList,
  GridTours,
  CCACardProfile,
  ImageFlip,
  GGMap,
  ContactForm,
  JobGrid,
  Benefits,
  ApplyForm,
  SKLFooter,
  SinglePost,
  CCAFormCustomizeTour,
  CareersFooter,
  CCACustomMedia,
}

export const common = {
  categories: {
    layout: {
      title: "Layout",
      components: ["Container", "Columns", "Box", "VericalSpace"],
    },
    content: {
      title: "Content",
      components: ["Heading", "Text", "Button", "ButtonLocation", "DropDown"],
    },
    media: {
      title: "Media",
      components: ["ImageConfig", "ImageCard", "VideoConfig", "PhotoLibrary", "VideoLibrary", "IconSocial"],
    },
    data: {
      title: "Data",
      components: [
        "GalleryLayoutConfig",
        "GalleryConfig",
        "ProfileUserCard",
        "SimpleSliderConfig",
        "PostGridByCategoryConfig",
        "CustomTabs",
      ],
    },
    theme: {
      title: "Themes - Skylink Studio",
      components: [
        "GameSlider",
        "GameGrid",
        "GridImageSKS",
        "VideoAutoPlay",
        "GGMap",
        "ContactForm",
        "JobGrid",
        "Benefits",
        "ApplyForm",
        "SKLFooter",
      ],
      defaultExpanded: false,
    },
    themes: {
      title: "Themes - SKE",
      components: [
        "SKETitle",
        "SKEActionButton",
        "SKEContentHeading",
        "SKEContentText",
        "SKEContentDescription",
        "MultiLayout",
        "SKERecruiment",
        "RelationshipLayout",
        "SKEEnrollmentProcess",
        "SKEEnrollmentCard",
        "SKESchoolSystem",
        "SKESimpleSlider",
        "ImageSection",
        "ManCountdown",
        "ManDropDown",
        "SKEFooter",
        "SKEBaseSystem",
        "SKEContactForm",
        "SKEContactHero",
        "SKECustomTabs",
        "SKEEducationalCard",
        "SKEProcessSlide",
        "SKETabBlockWithMedia",
        "ImageFlip",
      ],
      defaultExpanded: false,
    },

    themesManu: {
      title: "Themes - Manu",
      components: ["SliderScroll", "FormRegister", "ButtonMA"],
      defaultExpanded: false,
    },
    themesManuBG: {
      title: "Themes - Manu Bac Giang",
      components: ["ButtonMABG", "ManuCountdownBG", "FormRegisterBG", "ManuDropDownBG"],
      defaultExpanded: false,
    },
    themesSKELandingpage: {
      title: "Themes - SKE Landing Page",
      components: [
        "SKELPEnrollmentCard",
        "SKELPGalleryLayout",
        "SKELPCustomTabs",
        "SKELPRegister",
        "SKELPTuitionCard",
        "SKELPFormRegister",
        "SKELPEnrollmentCard2",
        "SKELPPopup",
      ],
      defaultExpanded: false,
    },
    themesSkylinkCareers: {
      title: "Themes - Skylink Careers",
      components: [
        "BannerTrangChu",
        "CompaniesSection",
        "SeeMoreSection",
        "FindInput",
        "ImageGrid",
        "SectionFilter",
        "SectionQTTuyenDung",
        "DepartmentRecruitment",
        "CareersFooter",
      ],
      defaultExpanded: false,
    },
    themesCaoCao: {
      title: "Themes - CaoCao",
      components: [
        "CaoCaoButton",
        "CaoCaoCarousel",
        "CaoCaoFeedback",
        "CaoCaoFooter",
        "CaoCaoNavigation",
        "CaoCaoSlider",
        "CustomTours",
        "CaoCaoContact",
        "LocationMap",
        "ArticlesItemsList",
        "GridTours",
        "CCACardProfile",
        "SinglePost",
        "CCAFormCustomizeTour",
        "CCACustomMedia",
      ],
      defaultExpanded: false,
    },
  },
  root: {
    fields: {
      title: {
        type: "text",
        label: "Title",
      },
      breadcrumb: {
        type: "array",
        label: "Bread Crumb",
        min: 0,
        max: 4,
        arrayFields: {
          title: {
            type: "text",
            label: "Title",
          },
          link: {
            type: "text",
            label: "Link",
          },
        },
      },
    },
  },
}

// @ts-ignore
export const uiBuilderConfig: Config = {
  components: {
    ...components,
  },
  ...common,
}

// Below config is used for renderer only
// import { Config } from "@measured/puck"
import { RenderConfig as NewBox } from "./blocks/Box/RenderConfig"
import { RenderConfig as NewButton } from "./blocks/Button/RenderConfig"
import { ButtonLocation } from "./blocks/ButtonLocation"
import { RenderConfig as NewButtonLocation } from "./blocks/ButtonLocation/RenderConfig"
import { RenderConfig as NewColumns } from "./blocks/Columns/RenderConfig"
import { RenderConfig as NewContainer } from "./blocks/Container/RenderConfig"
import { DropDown } from "./blocks/DropDown"
import { RenderConfig as NewDropDown } from "./blocks/DropDown/RenderConfig"
import { RenderConfig as NewGallery } from "./blocks/Gallery/RenderConfig"
import { RenderConfig as NewGalleryLayout } from "./blocks/GalleryLayout/RenderConfig"
import { RenderConfig as NewHeading } from "./blocks/Heading/RenderConfig"
import { RenderConfig as NewIconSocial } from "./blocks/IconSocial/RenderConfig"
import { RenderConfig as NewImage } from "./blocks/Image/RenderConfig"
import { RenderConfig as NewImageCard } from "./blocks/ImageCard/RenderConfig"
import { RenderConfig as NewPhotoLibrary } from "./blocks/PhotoLibrary/RenderConfig"
import { RenderConfig as NewPostGridByCategory } from "./blocks/PostGridByCategory/RenderConfig"
import { RenderConfig as NewProfileUserCard } from "./blocks/ProfileUserCard/RenderConfig"
import { RenderConfig as NewSimpleSlider } from "./blocks/SimpleSliders/RenderConfig"
import { CustomTabs } from "./blocks/Tabs"
import { RenderConfig as NewCustomTabs } from "./blocks/Tabs/RenderConfig"
import { RenderConfig as NewText } from "./blocks/Text/RenderConfig"
import { RenderConfig as NewVericalSpace } from "./blocks/VerticalSpace/RenderConfig"
import { RenderConfig as NewVideo } from "./blocks/Video/RenderConfig"
import { RenderConfig as NewVideoLibrary } from "./blocks/VideoLibrary/RenderConfig"
import { RenderConfig as NewArticlesItemsList } from "./themes/caocao/ArticlesItemsList/RenderConfig"
import { RenderConfig as NewCaoCaoButton } from "./themes/caocao/CaoCaoButton/RenderConfig"
import { RenderConfig as NewCaoCaoCarousel } from "./themes/caocao/CaoCaoCarousel/RenderConfig"
import { RenderConfig as NewCaoCaoContact } from "./themes/caocao/CaoCaoContact/RenderConfig"
import { RenderConfig as NewCaoCaoFeedback } from "./themes/caocao/CaoCaoFeedback/RenderConfig"
import { RenderConfig as NewCaoCaoFooter } from "./themes/caocao/CaoCaoFooter/RenderConfig"
import { RenderCustomMedia } from "./themes/caocao/CaoCaoMedia/RenderConfig"
import { RenderConfig as NewCaoCaoNavigation } from "./themes/caocao/CaoCaoNavigation/RenderConfig"
import { RenderConfig as NewCaoCaoSlider } from "./themes/caocao/CaoCaoSlider/RenderConfig"
import { RenderConfig as NewCustomTours } from "./themes/caocao/CustomTours/RenderConfig"
import { RenderConfig as NewCCACardProfile } from "./themes/caocao/EnrollmentCard/RenderConfig"
import { RenderConfig as NewCCAFormCustomizeTour } from "./themes/caocao/FormCustomizeTour/RenderConfig"
import { GridTours } from "./themes/caocao/GridTours/CustomTours"
import { RenderGridTours } from "./themes/caocao/GridTours/RenderConfig"
import { RenderConfig as NewLocationMap } from "./themes/caocao/LocationMap/RenderConfig"
import { RenderSinglePost as NewSinglePost } from "./themes/caocao/SinglePost/RenderConfig"
import { RenderConfig as NewManuButtonBG } from "./themes/manu-bacgiang/Button/RenderConfig"
import { RenderConfig as NewManuCountdownBG } from "./themes/manu-bacgiang/Countdown/RenderConfig"
import { RenderConfig as NewManuFormRegisterBG } from "./themes/manu-bacgiang/FormRegister/RenderConfig"
import { RenderConfig as NewManuDropDownBG } from "./themes/manu-bacgiang/ManDropDown/RenderConfig"
import { RenderConfig as NewButtonMA } from "./themes/manu/Button/RenderConfig"
import { RenderConfig as NewFormRegister } from "./themes/manu/FormRegister/RenderConfig"
import { RenderConfig as NewManuSliderScroll } from "./themes/manu/SliderScroll/RenderConfig"
import { RenderConfig as NewSKELPEnrollmentCard2 } from "./themes/ske-landing-page/EnrollmentCard2/RenderConfig"
import { RenderConfig as NewSKELPFormRegister } from "./themes/ske-landing-page/FormRegister/RenderConfig"
import { RenderConfig as NewSKELPGalleryLayout } from "./themes/ske-landing-page/GalleryLayout/RenderConfig"
import { RenderConfig as NewSKELPRegister } from "./themes/ske-landing-page/SKESchoolSystem/RenderConfig"
import { RenderConfig as NewSKELPCustomTabs } from "./themes/ske-landing-page/Tabs/RenderConfig"
import { RenderConfig as NewSKELPTuitionCard } from "./themes/ske-landing-page/TuitionCard/SKEEnrollmentCard"
import { RenderConfig as NewSKEActionButton } from "./themes/ske/ActionButton/RenderConfig"
import { RenderConfig as NewSKEBaseSystem } from "./themes/ske/BaseSystem/RenderConfig"
import { RenderConfig as NewSKEContactForm } from "./themes/ske/ContactForm/RenderConfig"
import { RenderConfig as NewSKEContactHero } from "./themes/ske/ContactHero/RenderConfig"
import { RenderConfig as NewSKEContentDescription } from "./themes/ske/ContentDescription/RenderConfig"
import { RenderConfig as NewSKEContentHeading } from "./themes/ske/ContentHeading/RenderConfig"
import { RenderConfig as NewSKEContentText } from "./themes/ske/ContentText/RenderConfig"
import { RenderConfig as NewSKEEducationalCard } from "./themes/ske/EducationalCard/RenderConfig"
import { RenderConfig as NewSKEEnrollmentCard } from "./themes/ske/EnrollmentCard/RenderConfig"
import { RenderConfig as NewSKEEnrollmentProcess } from "./themes/ske/EnrollmentProcess/RenderConfig"
import { RenderConfig as NewImageFlip } from "./themes/ske/ImageFlip/RenderConfig"
import { RenderConfig as NewImageSection } from "./themes/ske/ImageSection/RenderConfig"
import { RenderConfig as NewMultiLayout } from "./themes/ske/MultiLayout/RenderConfig"
import { RenderConfig as NewSKEProcessSlide } from "./themes/ske/ProcessSlide/RenderConfig"
import { RenderConfig as NewRelationshipLayout } from "./themes/ske/RelationshipLayout/RenderConfig"
import { RenderConfig as NewSKENavigation } from "./themes/ske/SKENavigation/RenderConfig"
import { RenderConfig as NewSKERecruiment } from "./themes/ske/SKERecruitment/RenderConfig"
import { RenderConfig as NewSKESchoolSystem } from "./themes/ske/SKESchoolSystem/RenderConfig"
import { RenderConfig as NewSKESimpleSlider } from "./themes/ske/SKESimpleSlider/RenderConfig"
import { RenderConfig as NewSKETabBlockWithMedia } from "./themes/ske/SKETabBlockWithMedia/RenderConfig"
import { RenderConfig as NewSKECustomTabs } from "./themes/ske/Tabs/RenderConfig"
import { RenderConfig as NewSKETitle } from "./themes/ske/Tittle/RenderConfig"
import { RenderConfig as NewBannerTrangChu } from "./themes/skylink-careers/bannerTrangChu/RenderConfig"
import { RenderConfig as NewCompaniesSection } from "./themes/skylink-careers/CompaniesSection/RenderConfig"
import { RenderDepartmentRecruitment } from "./themes/skylink-careers/DepartmentRecruitment/RenderConfig"
import { RenderConfig as NewFindInput } from "./themes/skylink-careers/FindInput/RenderConfig"
import { RenderCareersFooter } from "./themes/skylink-careers/Footer/RenderConfig"
import { RenderConfig as NewGridImage } from "./themes/skylink-careers/GridImage/RenderConfig"
import { RenderConfig as NewSectionFilter } from "./themes/skylink-careers/SectionFilter/RenderConfig"
import { RenderConfig as NewSectionQTTuyenDung } from "./themes/skylink-careers/SectionQTTuyenDung/RenderConfig"
import { RenderConfig as NewSeeMoreSection } from "./themes/skylink-careers/SeeMoreSection/RenderConfig"
import { RenderConfig as NewApplyForm } from "./themes/skylink-studio/ApplyForm/RenderConfig"
import { RenderConfig as NewBenefits } from "./themes/skylink-studio/benefits/RenderConfig"
import { RenderConfig as NewContactForm } from "./themes/skylink-studio/ContactForm/RenderConfig"
import { RenderConfig as NewSKLFooter } from "./themes/skylink-studio/Footer/RenderConfig"
import { RenderConfig as NewGameGrid } from "./themes/skylink-studio/GameGrid/RenderConfig"
import { RenderConfig as NewGameSlider } from "./themes/skylink-studio/GameSlider/RenderConfig"
import { RenderConfig as NewGGMap } from "./themes/skylink-studio/GGMap/RenderConfig"
import { RenderConfig as NewGridImageSKS } from "./themes/skylink-studio/GridImage/RenderConfig"
import { RenderConfig as NewJobGrid } from "./themes/skylink-studio/JobGrid/RenderConfig"
import { RenderConfig as NewVideoAutoPlay } from "./themes/skylink-studio/Video/RenderConfig"

export const newRenderComponents = {
  Container: NewContainer,
  Columns: NewColumns,
  Box: NewBox,
  VericalSpace: NewVericalSpace,
  Heading: NewHeading,
  Text: NewText,
  Button: NewButton,
  CustomTabs: NewCustomTabs,
  ButtonLocation: NewButtonLocation,
  ImageConfig: NewImage,
  ImageCard: NewImageCard,
  VideoConfig: NewVideo,
  GalleryConfig: NewGallery,
  GalleryLayoutConfig: NewGalleryLayout,
  ProfileUserCard: NewProfileUserCard,
  SimpleSliderConfig: NewSimpleSlider,
  PostGridByCategoryConfig: NewPostGridByCategory,
  SKETitle: NewSKETitle,
  SKEActionButton: NewSKEActionButton,
  SKEContentHeading: NewSKEContentHeading,
  SKEContentText: NewSKEContentText,
  SKEContentDescription: NewSKEContentDescription,
  PhotoLibrary: NewPhotoLibrary,
  VideoLibrary: NewVideoLibrary,
  DropDown: NewDropDown,
  // New components
  MultiLayout: NewMultiLayout,
  SKERecruiment: NewSKERecruiment,
  IconSocial: NewIconSocial,
  RelationshipLayout: NewRelationshipLayout,
  SKEEnrollmentProcess: NewSKEEnrollmentProcess,
  SKEEnrollmentCard: NewSKEEnrollmentCard,
  ImageSection: NewImageSection,
  ManCountdown: ManCountdown,
  Input: Input,
  ManDropDown: ManDropDown,
  SliderScroll: NewManuSliderScroll,
  FormRegister: NewFormRegister,
  ButtonMA: NewButtonMA,
  SKESchoolSystem: NewSKESchoolSystem,
  SKESimpleSlider: NewSKESimpleSlider,
  SKEFooter: SKEFooter,
  SKENavigation: NewSKENavigation,
  ButtonMABG: NewManuButtonBG,
  ManuCountdownBG: NewManuCountdownBG,
  FormRegisterBG: NewManuFormRegisterBG,
  ManuDropDownBG: NewManuDropDownBG,
  BannerTrangChu: NewBannerTrangChu,
  CompaniesSection: NewCompaniesSection,
  SeeMoreSection: NewSeeMoreSection,
  FindInput: NewFindInput,
  ImageGrid: NewGridImage,
  SectionFilter: NewSectionFilter,
  SectionQTTuyenDung: NewSectionQTTuyenDung,
  SKELPEnrollmentCard: SKELPEnrollmentCard,
  SKELPGalleryLayout: NewSKELPGalleryLayout,
  SKELPCustomTabs: NewSKELPCustomTabs,
  SKELPRegister: NewSKELPRegister,
  SKELPTuitionCard: NewSKELPTuitionCard,
  SKELPFormRegister: NewSKELPFormRegister,
  SKELPEnrollmentCard2: NewSKELPEnrollmentCard2,
  GameSlider: NewGameSlider,
  GameGrid: NewGameGrid,
  GridImageSKS: NewGridImageSKS,
  VideoAutoPlay: NewVideoAutoPlay,
  CaoCaoButton: NewCaoCaoButton,
  CaoCaoCarousel: NewCaoCaoCarousel,
  CaoCaoFeedback: NewCaoCaoFeedback,
  CaoCaoFooter: NewCaoCaoFooter,
  CaoCaoNavigation: NewCaoCaoNavigation,
  CaoCaoSlider: NewCaoCaoSlider,
  CustomTours: NewCustomTours,
  CaoCaoContact: NewCaoCaoContact,
  LocationMap: NewLocationMap,
  SKECustomTabs: NewSKECustomTabs,
  SKEEducationalCard: NewSKEEducationalCard,
  SKEProcessSlide: NewSKEProcessSlide,
  SKEBaseSystem: NewSKEBaseSystem,
  SKEContactForm: NewSKEContactForm,
  SKEContactHero: NewSKEContactHero,
  DepartmentRecruitment: RenderDepartmentRecruitment,
  SKETabBlockWithMedia: NewSKETabBlockWithMedia,
  ArticlesItemsList: NewArticlesItemsList,
  GridTours: RenderGridTours,
  CCACardProfile: NewCCACardProfile,
  ImageFlip: NewImageFlip,
  GGMap: NewGGMap,
  ContactForm: NewContactForm,
  JobGrid: NewJobGrid,
  Benefits: NewBenefits,
  ApplyForm: NewApplyForm,
  SKLFooter: NewSKLFooter,
  SinglePost: NewSinglePost,
  CCAFormCustomizeTour: NewCCAFormCustomizeTour,
  CareersFooter: RenderCareersFooter,
  CCACustomMedia: RenderCustomMedia,
}

// @ts-ignore
export const newRenderConfig: Config = {
  components: {
    ...newRenderComponents,
  },
  ...common,
}
